import { SuperModel } from './super-model.model';
import { Color } from './color.model';

export class EventCategory extends SuperModel {
  title: string;
  color: Color;

  constructor(data: Partial<EventCategory> = {}) {
    super(data);
    if (data.color) {
      this.color = new Color(data.color);
    }
  }

  get serialised() {
    return {
      title: this.title,
      color: this.color && this.color.serialised,
    };
  }
}
